import { faCommentQuestion, faQuestion, faThumbsDown, faThumbsUp } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { ContentTaskStatusGq } from '../../../../../graphql/projects/models/ContentTaskStatusGq';


export const ApprovedTextFilter: React.FC<{ status: ContentTaskStatusGq }> = ({ status }) => {
  return (
    <>
      {status === ContentTaskStatusGq.UNDECIDED && 'Undecided'}
      {status === ContentTaskStatusGq.APPROVED && 'Approved'}
      {status === ContentTaskStatusGq.DISAPPROVED && 'Disapproved'}
      {status === ContentTaskStatusGq.PROPOSAL && 'Proposal'}
    </>
  );
};

export const ApprovedTextSetState: React.FC<{ status: ContentTaskStatusGq }> = ({ status }) => {
  return (
    <>
      {status === ContentTaskStatusGq.UNDECIDED && 'Set filtered as Undecided'}
      {status === ContentTaskStatusGq.APPROVED && 'Set filtered as Approved'}
      {status === ContentTaskStatusGq.DISAPPROVED && 'Set filtered as Disapproved'}
      {status === ContentTaskStatusGq.PROPOSAL && 'Set filtered as Proposed'}
    </>
  );
};

export const ApprovedIcon: React.FC<{
  status: ContentTaskStatusGq;
  size: 'medium' | 'large' | 'small';
}> = ({ status, size }) => {
  return (
    <>
      {status === ContentTaskStatusGq.UNDECIDED && (
        <FontAwesomeIcon icon={faQuestion} />
      )}
      {status === ContentTaskStatusGq.APPROVED && (
        <FontAwesomeIcon icon={faThumbsUp} />
      )}
      {status === ContentTaskStatusGq.PROPOSAL && (
        <FontAwesomeIcon icon={faCommentQuestion} />
      )}
      {status === ContentTaskStatusGq.DISAPPROVED && (
        <FontAwesomeIcon icon={faThumbsDown} />
      )}
    </>
  );
};
